import { BaseResponse } from './base-response.model';

export interface FinanceChargedDepartmentsResponse extends BaseResponse {
	message: string;
	financeChargedDepartments: FinanceChargedDepartmentJSON[];
}

export interface FinanceChargedDepartmentJSON {
	description: string;
	key: string;
}

export class FinanceChargedDepartment {
	constructor(
		public description: string,
		public key: string
	) {}

	static fromJSON(
		json: FinanceChargedDepartmentJSON
	): FinanceChargedDepartment {
		const department = Object.create(FinanceChargedDepartment.prototype);
		return Object.assign(department, json, {});
	}
}
